import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SUPPORT_WHATSAPP_URL = process.env.REACT_APP_SUPPORT_WHATSAPP_URL || process.env.REACT_APP_BANK_TRANSFER_WHATSAPP_URL || 'https://wa.me/593998152432';
const SUPPORT_WHATSAPP_NUMBER = process.env.REACT_APP_SUPPORT_WHATSAPP_NUMBER || process.env.REACT_APP_BANK_TRANSFER_WHATSAPP_NUMBER || '0998152432';
const MIN_ACTIVE_REFERRALS_FOR_WITHDRAWAL = Number(process.env.REACT_APP_MIN_ACTIVE_REFERRALS_FOR_WITHDRAWAL || 3);
const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('vg_token'));
  const [loading, setLoading] = useState(true);

  const getHeaders = useCallback(() => ({
    Authorization: `Bearer ${token}`
  }), [token]);

  const fetchMe = useCallback(async (t) => {
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${t || token}` }
      });
      setUser(res.data);
    } catch {
      setToken(null);
      setUser(null);
      localStorage.removeItem('vg_token');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      fetchMe(token);
    } else {
      setLoading(false);
    }
  }, [token, fetchMe]);

  const login = async (country_code, phone_number, password) => {
    const res = await axios.post(`${API}/auth/login`, { country_code, phone_number, password });
    const { token: t, user: u } = res.data;
    setToken(t);
    setUser(u);
    localStorage.setItem('vg_token', t);
    return u;
  };

  const register = async (country_code, phone_number, full_name, password, referral_code) => {
    const res = await axios.post(`${API}/auth/register`, { country_code, phone_number, full_name, password, referral_code });
    const { token: t, user: u } = res.data;
    setToken(t);
    setUser(u);
    localStorage.setItem('vg_token', t);
    return u;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('vg_token');
  };

  const refreshUser = () => fetchMe(token);

  return (
    <AuthContext.Provider value={{
      user, token, loading, login, register, logout, getHeaders, refreshUser, API,
      SUPPORT_WHATSAPP_URL, SUPPORT_WHATSAPP_NUMBER, MIN_ACTIVE_REFERRALS_FOR_WITHDRAWAL,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
